<template>
  <div class="page-user-edit">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">好物兌換商品</div>
      <div class="breadcrumb-item">好物兌換-修改好物商品</div>
    </div>
	  <!-- {{this.defaultList}} -->
    <div class="pg-block">
      <div class="pg-form-wrap">
        <Spin fix class="pg-sub-loading" v-if="isSubmiting">
          <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
          <div class="loading-text">Loading</div>
        </Spin>
        <Row>
          <Col span="25" push="1">
            <Form :label-width="100">
              <Row :gutter="15">
                <Col span="17">
                  <Steps :current="current">
                    <Step title="填寫商品信息"></Step>
                    <Step title="填寫商品促銷"></Step>
                    <Step title="填寫商品屬性"></Step>
                  </Steps>
                </Col>
              </Row>
              <br>
              <br>
              <div v-show="this.current == 0">

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>商品類型</span>
                      </div>
                      <Select ref="select_order" style="width: 200px;height: 40px;margin-right:50px;border-radius: 6px;"
                              clearable placeholder="商品類型" v-model="form.order_type">
												<Option :value="-1">
													优惠卷
												</Option>
                        <Option :value="item.id" v-for="(item, index) in orderTypes" :key="item.name">
                          {{ item.name }}
                        </Option>
                      </Select>
                    </FormItem>
                  </Col>
                </Row>

								<Row :gutter="15" v-if="form.order_type==-1">
									<Col span="14">
										<FormItem>
											<div slot="label" class="form-label">
												<em class="red">* </em>
												<span>兑换商家</span>
											</div>
											<Select style="width: 200px;height: 40px;margin-right:50px;border-radius: 6px;" clearable
															placeholder="兑换商家" v-model="form.seller_id">
												<Option :value="item.id" v-for="(item, index) in sellerList" :key="item.id">
													{{ item.seller_name }}
												</Option>
											</Select>
										</FormItem>
									</Col>
								</Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>商品名稱</span>
                      </div>
                      <Input v-model="form.order_name" placeholder="商品名稱" clearable/>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>副標題</span>
                      </div>
                      <Input v-model="form.order_title" max="100" min="1" placeholder="副標題" clearable/>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>商品介紹</span>
                      </div>
                      <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="商品介紹"
                             v-model="form.product_desciption" maxlength="100" show-word-limit clearable/>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <span>計量單位</span>
                      </div>
                      <Input v-model="form.order_unit" placeholder="計量單位" clearable/>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>庫存</span>
                      </div>
                      <span style="width:28%;margin-right:10px;">{{ form.order_inventory_edit }}</span>

                      +/-

                      <Input type="number" max="9999" min="0" placeholder="減庫存請用 - 號"
                             style="width:28%;margin-left:10px;margin-right:10px;" v-model="form.order_inventory"
                             clearable/>

                      =

                      <span
	                      style="width:28%;margin-right:10px;">{{ Number(form.order_inventory) + Number(form.order_inventory_edit) }}</span>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>購買限制</span>
                      </div>
                      <Input type="number" v-model="form.purchase_restrictions" max="99999" min="0" placeholder="購買限制"
                             clearable/>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>APP排序</span>
                      </div>
                      <Input v-model="form.order_srot_app" type="number" max="99999" min="0" placeholder="APP排序"
                             clearable/>
                    </FormItem>
                  </Col>
                </Row>
              </div>

              <div v-show="this.current == 1">

                <Row :gutter="20">
                  <Col span="20">
                    <FormItem>
                      <Spin fix class="pg-sub-loading" v-show="dialogVisible == false">
                        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                        <div class="loading-text">Loading</div>
                      </Spin>
                      <div slot="label" class="form-label">
                        <!-- <em class="red">* </em> -->
                        <span>標簽</span>
                      </div>

                      <el-table :data="diskData" height="200">

                        <el-table-column prop="id" label="標簽序號" show-overflow-tooltip>
                          <template slot-scope="scope">
                                                    <span v-if="scope.row.start !='0' || scope.row.start == undefined">
                                                        {{ scope.row.id }}
                                                    </span>
                          </template>
                        </el-table-column>

                        <el-table-column prop="name" label="標簽名稱" show-overflow-tooltip>
                          <template slot-scope="scope">
                                                    <span v-if="scope.row.start !='0' || scope.row.start == undefined">
                                                        {{ scope.row.name }}
                                                    </span>
                            <el-input size="small" v-model="tableInput.disk.name" v-if="scope.row.start =='0'"
                                      style="width:80%;"></el-input>
                          </template>
                        </el-table-column>

                        <el-table-column prop="status" label="是否開啓" show-overflow-tooltip :reserve-selection="true">
                          <template slot-scope="scope" v-if="scope.row.start==1">
                            <el-radio v-model="checkedIndex" :label="scope.$index"
                                      @change.native="handleSelectionChange(scope.row.id,scope.$index)">{{ '' }}
                            </el-radio>
                          </template>
                        </el-table-column>

                        <el-table-column label="操作">
                          <template slot-scope="scope">
                            <el-button size="mini" type="danger"
                                       v-if="scope.row.start !='0' || scope.row.start == undefined"
                                       @click="handleDelete(scope.$index,'disk',scope.row.id)">
                              <i class="iconfont icon-delete">刪除</i>
                            </el-button>

                            <el-button size="mini" type="primary" v-if="scope.row.start =='0'"
                                       @click="handleAdd(scope.$index,'disk')">
                              <i class="iconfont icon-add">添加</i>
                            </el-button>

                            <el-button size="mini" type="warning" v-if="scope.row.start =='0'"
                                       @click="handleSelectionChange_Clear">
                              <i class="iconfont icon-add">清空選擇</i>
                            </el-button>
                          </template>
                        </el-table-column>

                      </el-table>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>開始時間</span>
                      </div>
                      <DatePicker type="date" format="yyyy-MM-dd" :transfer="true" v-model="form.order_release_time"
                                  style="width:100%;" :clearable="false" placeholder="選擇開始時間"/>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>結束時間</span>
                      </div>
                      <DatePicker type="date" format="yyyy-MM-dd" :transfer="true" v-model="form.order_close_time"
                                  style="width:100%;" :clearable="false" placeholder="選擇結束時間"/>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>市場價</span>
                      </div>
                      <Input v-model="form.price" type="number" max="99999" min="0"
                             placeholder="市場價 (必需要跟積分和集金幣的價格相加一致)" clearable/>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>積分價格</span>
                      </div>
                      <Input v-model="form.integral_price" max="9999" min="0" placeholder="積分價格" clearable/>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>集金幣價格</span>
                      </div>
                      <Input v-model="form.jpoint_price" max="9999" min="0" placeholder="集金幣價格" clearable/>
                    </FormItem>
                  </Col>
                </Row>
              </div>
              <div v-show="this.current == 2">

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>主商品圖</span>
                      </div>

                      <div class="demo-upload-list" v-for="item in defaultList" v-show="item.type == 1">
                        <template v-if="item.image_path != '' && item.type == 1">
                          <img :src="item.image_path">
                          <div class="demo-upload-list-cover">
                            <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                            <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                          </div>
                        </template>
                        <template v-else>
                          <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                        </template>
                      </div>

                      <Upload
	                      ref="upload"
	                      :show-upload-list="false"
	                      :format="['jpg','jpeg','png']"
	                      :max-size="2048"
	                      :on-success="handleSuccess_main"
	                      :on-format-error="handleFormatError"
	                      :on-exceeded-size="handleMaxSize"
	                      :before-upload="handleBeforeUpload_main"
	                      type="drag"
	                      :action="uploadUrl+'/api/v1/test/update/s3/update'"
	                      style="display: inline-block;width:58px;">
                        <div style="line-height: 58px;">
                          <Icon type="ios-camera" size="20"></Icon>
                        </div>
                      </Upload>

	                    <!-- <Modal title="查閱圖片" v-model="visible" :footer-hide="true">
													<img :src="imgName" v-if="visible" style="width: 100%">
											</Modal> -->

                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <span>商品輪播圖</span>
                      </div>

                      <div class="demo-upload-list" v-for="item in defaultList" v-show="item.type == 2">
                        <template v-if="item.image_path != '' && item.type == 2">
                          <img :src="item.image_path">
                          <div class="demo-upload-list-cover">
                            <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                            <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                          </div>
                        </template>
                        <template v-else>
                          <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                        </template>
                      </div>

                      <Upload
	                      ref="upload"
	                      :show-upload-list="false"
	                      :format="['jpg','jpeg','png']"
	                      :max-size="2048"
	                      :on-success="handleSuccess"
	                      :on-format-error="handleFormatError"
	                      :on-exceeded-size="handleMaxSize"
	                      type="drag"
	                      :action="uploadUrl+'/api/v1/test/update/s3/update'"
	                      style="display: inline-block;width:58px;">
                        <div style="line-height: 58px;">
                          <Icon type="ios-camera" size="20"></Icon>
                        </div>
                      </Upload>

                      <Modal title="查閱圖片" v-model="visible" :footer-hide="true">
                        <img :src="imgName.image_path" v-if="visible" style="width: 100%">
                      </Modal>

                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>規格參數</span>
                      </div>
                      <RadioGroup v-model="form.order_paramter_type">
                        <Radio :label="'0'">
                          <span>電腦端詳情</span>
                        </Radio>
                        <Radio :label="'1'">
                          <span>移動端詳情</span>
                        </Radio>
                      </RadioGroup>
                    </FormItem>
                  </Col>
                </Row>

                <FormItem>
                  <div slot="label" class="form-label">
                  </div>
                  <textarea v-model="form.order_parameter" hidden readonly></textarea>
                  <div id="demo1" style="width:95%"></div>
                </FormItem>

                <Row :gutter="15">
                  <Col span="14">
                    <FormItem>
                      <div slot="label" class="form-label">
                        <em class="red">* </em>
                        <span>是否開啟</span>
                      </div>
                      <RadioGroup v-model="form.order_shelf">
                        <Radio :label="'1'">
                          <span>是</span>
                        </Radio>
                        <Radio :label="'0'">
                          <span>否</span>
                        </Radio>
                      </RadioGroup>
                    </FormItem>
                  </Col>
                </Row>

              </div>
              <Row :gutter="200">
                <Col span="200">
                  <FormItem>
                    <div class="pg-btn-wrap">
                      <div v-if="this.current == 1" class="pg-btn"
                           style="width:25%;background: #FFFFFF;opacity: 1;border-radius: 6px;" @click="preview()">
                        {{ statusReturn }}
                      </div>
                      <div v-if="this.current == 0" class="pg-btn"
                           style="width:25%;background: #FFFFFF;opacity: 1;border-radius: 6px;" @click="handleBack()">
                        {{ statusback }}
                      </div>
                      <div v-if="this.current == 0" class="pg-btn style1"
                           style="width:25%;background: #FF466B;opacity: 1;border-radius: 6px;"
                           @click="handleCheckForm()">
                        {{ statusFirst }}
                      </div>
                      <div v-if="this.current == 1" class="pg-btn style1"
                           style="width:25%;background: #FF466B;opacity: 1;border-radius: 6px;"
                           @click="handleCheckForm()">
                        {{ statusSecond }}
                      </div>
                      <div v-if="this.current == 2" class="pg-btn"
                           style="width:25%;background: #FFFFFF;opacity: 1;border-radius: 6px;" @click="preview()">
                        {{ statusReturnSecond }}
                      </div>
                      <div v-if="this.current == 2" class="pg-btn style1"
                           style="width:25%;background: #FF466B;opacity: 1;border-radius: 6px;"
                           @click="handleCheckForm()">
                        {{ statusDone }}
                      </div>
                    </div>
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import wangEditor from 'wangeditor';
const uploadUrl = process.env.VUE_APP_API_URL
export default {
	data() {
		return {
			checked: null,
			pageParam: {},
			detail: {},
			isSubmiting: false,
			statusReturn: '上一步，填寫商品信息',
			statusReturnSecond: '上一步，填寫商品促銷',
			statusback: '返回',
			statusFirst: '下一步，填寫商品促銷',
			statusSecond: '下一步，填寫商品屬性',
			statusDone: '完成，修改商品',
			current: 0,
			form: {
				order_type: '',
				order_name: '',
				order_title: '',
				order_inventory: 0,
				order_inventory_edit: 0,
				order_srot_app: 0,
				product_desciption: '',
				purchase_restrictions: 0,
				order_release_time: '',
				order_close_time: '',
				integral_price: 0,
				jpoint_price: 0,
				price: 0,
				order_unit: '個',
				order_parameter: '',
				order_shelf: '',
				order_paramter_type: '',
				order_label_id: '',
				order_label_status: "0",
				order_images: [],
				seller_id: ''
			},
			diskData: [],
			tableInput: {
				disk: {
					id: null,
					name: null,
					start: '0',
					disabled: false,
				},
			},
			dialogVisible: false,
			defaultList: [],
			imgName: '',
			visible: false,
			uploadList: [],
			uploadFile: {
				file: '',
				base64: '',
			},
			editor: null,
			editorData: '',
			templateSelection: {},
			tempArr_image: [],
			checkedIndex: null,
			orderTypes: [],
			uploadUrl,
			sellerList: []
		};
	},
	created() {
		this.getOrderTypeList()
		this.getOrderSellerList()
	},
	mounted() {
		this.pageParam = this.$route.query;
		if (this.pageParam.id == undefined) {
			this.pageParam.id = 0;
		} else {
			this.getList(this.pageParam.id);

			this.uploadList = this.$refs.upload.fileList;
			const editor = new wangEditor(`#demo1`);
			editor.config.menus = [
				'bold', // 粗体
				'fontSize', // 字号
				'fontName', // 字体
				'italic', // 斜体
				'underline', // 下划线
				'strikeThrough', // 删除线
				'foreColor', // 文字颜色
				'link', // 插入链接
				'list', // 列表
				'justify', // 对齐方式
				'quote', // 引用
				'image', // 插入图片
				'location', // 位置
			];
			editor.config.onchange = (newHtml) => {
				this.form.order_parameter = newHtml;
			}
			editor.config.placeholder = '文章內容';
			editor.config.focus = true;
			editor.config.uploadImgServer = uploadUrl + '/api/v1/test/update/s3/update';
			editor.config.uploadFileName = 'file'; //后端接受上传文件的参数名
			editor.config.uploadImgMaxSize = 10 * 1024 * 1024; // 将图片大小限制为 10M
			editor.config.uploadImgMaxLength = 1; // 限制一次最多上传 1 张图片
			editor.config.uploadImgHooks = {
				fail: (xhr, editor, result) => {
					// 插入图片失败回调
					console.log(result);
				},
				success: (xhr, editor, result) => {
					// 图片上传成功回调
					console.log(result);
				},
				timeout: (xhr, editor) => {
					// 网络超时的回调
					console.log('網絡超時');
				},
				error: (xhr, editor) => {
					// 图片上传错误的回调
					console.log('上傳錯誤');
				},
				//回显
				customInsert: (insertImg, result, editor) => {
					console.log(result)
					insertImg(result.data.path);
				},
			};
			editor.create();
			this.editor = editor;
		}
	},
	methods: {
		getOrderTypeList() {
			this.$Rq.requestAuth({
				url: this.$Api.ordertypeOnList,
				method: 'get',
				data: {
					name: this.name
				}
			}).then((res) => {
				if (res.code == 0) {
					this.orderTypes = res.data.data
				} else {
					this.orderTypes = []
				}
			})
		},
		getOrderSellerList() {
			this.$Rq.requestAuth({
				url: this.$Api.orderSellerOnList,
				method: 'get'
			}).then((res) => {
				console.log(res)
				if (res.list.length) {
					this.sellerList = res.list
				} else {
					this.sellerList = []
				}
			})
		},
		getList(order_id) {
			this.$Rq.requestAuth({
				url: this.$Api.commodityList,
				method: 'get',
				data: {
					order_id: order_id,
					offset: 0,
					limit: 1
				}
			}).then((res) => {
				if (res.code == 0) {
					let resData = res.data.data[0];
					const order_type = resData.category == 1 ? -1 : +resData.order_type
					this.form = {
						order_type,
						order_name: resData.order_name,
						order_title: resData.order_titile,
						order_inventory: "0",
						order_inventory_edit: resData.order_inventory,
						order_srot_app: resData.order_srot_app,
						product_desciption: resData.product_desciption,
						purchase_restrictions: resData.purchase_restrictions,
						order_release_time: resData.order_release_time,
						order_close_time: resData.order_close_time,
						integral_price: resData.integral_price,
						jpoint_price: resData.jpoint_price,
						price: resData.price,
						order_unit: resData.order_unit == null ? '個' : resData.order_unit,
						// order_parameter: resData.order_parameter,
						order_shelf: resData.order_shelf,
						order_label_id: resData.order_label_id,
						order_label_status: resData.order_label_status,
						order_images: resData.orderimages,
						order_parameter: resData.orderdoc == null ? '- - -' : resData.orderdoc.order_info,
						order_paramter_type: resData.orderdoc == null ? '- - -' : resData.orderdoc.type,
						seller_id: resData.seller_id
					}

					this.checked = Number(resData.order_label_id);
					this.defaultList = resData.orderimages;
					this.editor.txt.html(this.form.order_parameter);
				}
			}).catch((err) => {
			});
		},
		handleSelectionChange(id, index) {
			let form = this.form;
			form.order_label_id = id;
			form.order_label_status = "1";
		},
		handleSelectionChange_Clear() {
			let form = this.form;
			form.order_label_id = '';
			form.order_label_status = "0";
			this.checked = null;
			this.checkedIndex = null;
		},
		handleViewOrderLabel() {
			this.dialogVisible = false;
			this.$Rq.requestAuth({
				url: this.$Api.orderlabelList,
				method: 'get',
			}).then((res) => {
				if (res.code == 0) {
					let tempArr = [];
					let selecrid = this.checked;
					let resData = res.data.data;
					let ischecked = false;
					for (let i = 0; i < resData.length; i++) {
						// console.log("resData",resData[i].id);
						// console.log("selecrid",selecrid);

						if (resData[i].id == selecrid) {
							// console.log('第几个',i)
							ischecked = true
							this.checkedIndex = i;
						}

						tempArr.push({
							id: resData[i].id,
							name: resData[i].name,
							start: '1',
							ischecked
						});
					}
					tempArr.push({
						id: null,
						name: null,
						start: 0,
						ischecked
					});
					this.diskData = tempArr;
					this.dialogVisible = true;
					// console.log(this.diskData);
					// console.log("选择第:"+this.checkedIndex);
				} else {
					let tempArr = [];
					tempArr.push({
						id: '',
						name: '',
						start: 0,
						disabled: false,
					});
					this.diskData = tempArr;
					this.dialogVisible = true;
				}

			});
		},
		handleView(item) {
			this.imgName = item;
			this.visible = true;
		},
		handleRemove(file) {
			const fileList = this.defaultList;
			this.defaultList.splice(fileList.indexOf(file), 1);
		},
		handleSuccess(res, file) {
			this.defaultList.push({
				image_path: res.data.path,
				type: 2,
			});
			this.form.order_images = this.defaultList;
		},
		handleSuccess_main(res, file) {
			this.defaultList.push({
				image_path: res.data.path,
				type: 1,
			});
			this.form.order_images = this.defaultList;
		},
		handleFormatError(file) {
			this.$Utils.showTipInfo('文件格式不正確, 文件格式為' + file.name + '正確，請選擇jpg或png。');
		},
		handleMaxSize(file) {
			this.$Utils.showTipInfo('超過文件大小限制文件' + file.name + '太大了，不超過2M。');
		},
		handleBeforeUpload_main() {
			const check = this.defaultList.filter(item => item.type == "1").length < 1;
			if (!check) {
				this.$Utils.showTipInfo('最多可以上傳一張圖片。');
			}
			return check;
		},
		next() {
			let form = this.form;
			if (this.current == 0) {
				if (form.order_name === '') {
					this.$Utils.showTipInfo('請輸入商品名稱');
					return;
				}
				if (form.order_title === '') {
					this.$Utils.showTipInfo('請輸入副標題');
					return;
				}
				if (form.product_desciption === '') {
					this.$Utils.showTipInfo('請輸入商品介紹');
					return;
				}
				if (form.order_inventory === '') {
					this.$Utils.showTipInfo('請輸入庫存');
					return;
				}
				if (form.order_srot_app === '') {
					this.$Utils.showTipInfo('請輸入APP排序');
					return;
				}
				this.handleViewOrderLabel();
				this.current += 1;
			} else if (this.current == 1) {
				// if (form.order_label_status === "0") {
				//    this.$Utils.showTipInfo('請選擇標簽');
				//    return;
				// }
				if (form.order_release_time === '') {
					this.$Utils.showTipInfo('請選擇開始時間');
					return;
				}
				if (form.order_close_time === '') {
					this.$Utils.showTipInfo('請選擇結束時間');
					return;
				}
				if (form.purchase_restrictions === '') {
					this.$Utils.showTipInfo('請輸入購買限制');
					return;
				}
				if (form.price === '') {
					this.$Utils.showTipInfo('請輸入市場價格');
					return;
				}
				if (form.integral_price === '') {
					this.$Utils.showTipInfo('請輸入積分價格');
					return;
				}
				if (form.jpoint_price === '') {
					this.$Utils.showTipInfo('請輸入集金幣價格');
					return;
				}
				this.current += 1;
			} else if (this.current == 2) {
				if (form.order_paramter_type === '') {
					this.$Utils.showTipInfo('請選擇規格參數');
					return;
				}
				if (form.order_parameter === '') {
					this.$Utils.showTipInfo('請輸入規格參數的文章內容');
					return;
				}
				if (form.order_shelf === '') {
					this.$Utils.showTipInfo('請選擇是否開啟');
					return;
				}

				// this.current = 0;
				this.handleSubmit();
			}
		},
		preview() {
			this.current -= 1;
		},
		handleBack() {
			this.$router.go(-1);
		},
		hanldeImgToBase64() {
			let file = this.uploadFile.file;
			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				let _base64 = reader.result;
				this.uploadFile.base64 = _base64;
			};
			this.handleUploadImg();
		},
		handleUploadImg() {
			this.isSubmiting = true;
			let formData = new FormData();
			formData.append('file', this.uploadFile.file);
			this.$Rq.requestAuth({
				url: this.$Api.commodityUploadImg,
				method: 'post',
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data',
				}
			}).then((res) => {
				this.isSubmiting = false;
				if (res.code == 0) {
					this.tempArr_image.push({
						image_path: res.data.app_url + res.data.url,
						type: 1,
					});
					this.defaultList.push({
						url: res.data.app_url + res.data.url,
						name: 1,
					});
					this.form.order_images = this.tempArr_image;
				} else {
					this.$Utils.showTipInfo(res.msg);
				}
			}).catch((err) => {
				this.isSubmiting = false;
			});
		},
		formatDate(datetime) {
			if (!datetime) return '';
			let dateTime = new Date(datetime);
			let year = dateTime.getFullYear();
			let month = dateTime.getMonth() + 1;
			let date = dateTime.getDate();
			let milliseconds = dateTime.getMilliseconds();
			return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)}`;
		},
		formatNum(num) {
			return num < 10 ? '0' + num : num;
		},
		handleCheckForm() {
			this.next();
		},
		handleAdd(index, ipTable) {
			switch (ipTable) {
				case 'disk':
					if (this.tableInput.disk.name == '' || this.tableInput.disk.name == null || this.tableInput.disk.name.trim() <= 0) {
						this.$message.error('請輸入標簽名稱');
						return;
					}
					let tempRow = JSON.parse(JSON.stringify(this.tableInput.disk));
					tempRow.start = '1';
					this.dialogVisible = false;
					this.$Rq.requestAuth({
						url: this.$Api.orderlabelAdd,
						method: 'post',
						data: {
							name: this.tableInput.disk.name
						}
					}).then((res) => {
						if (res.code == 0) {
							this.$Utils.showSuccess(res.msg);
							this.diskData.splice(-1, 0, tempRow);
							this.tableInput.disk = [];
							this.handleViewOrderLabel();
							this.checked = null;
							this.checkedIndex = null;
							this.form.order_label_status = "0";
							this.form.order_label_id = '';
						} else {
							this.dialogVisible = true;
							this.$Utils.showTipInfo(res.msg);
						}
					}).catch((err) => {
						this.dialogVisible = true;
					});
					break;
			}
		},
		handleDelete(index, ipTable, id) {
			switch (ipTable) {
				case 'disk':
					this.dialogVisible = false;
					this.$Rq.requestAuth({
						url: this.$Api.orderlabelDelete,
						method: 'post',
						data: {
							orderlabel_id: id
						}
					}).then((res) => {
						if (res.code == 0) {
							this.dialogVisible = true;
							this.$Utils.showSuccess(res.msg);
							this.diskData.splice(index, 1);
							this.handleViewOrderLabel();
							this.checked = null;
							this.checkedIndex = null;
							this.form.order_label_status = "0";
							this.form.order_label_id = '';
						} else {
							this.dialogVisible = true;
							this.$Utils.showTipInfo(res.msg);
							this.diskData = [{"id": null, "name": null, "start": "0"}];
						}
					}).catch((err) => {
						this.dialogVisible = true;
					});
					break;
				default:
			}
		},
		handleSubmit() {
			let form = this.form;
			this.isSubmiting = true;
			// category 1:优惠卷 0:商品
			// seller_id 第三方核销id
			const category = form.order_type == '-1' ? '1' : '0'
			const order_type = form.order_type == '-1' ? '0' : form.order_type
			const seller_id = form.order_type == '-1' ? form.seller_id : '0'

			this.$Rq.requestAuth({
				url: this.$Api.commodityEdit,
				method: 'post',
				data: {
					order_id: this.pageParam.id,
					order_type,
					order_name: form.order_name,
					order_titile: form.order_title,
					product_desciption: form.product_desciption,
					price: Number(form.price),
					jpoint_price: Number(form.jpoint_price),
					integral_price: Number(form.integral_price),
					order_inventory: Number(form.order_inventory),
					order_release_time: this.formatDate(form.order_release_time),
					order_close_time: this.formatDate(form.order_close_time),
					order_label_id: form.order_label_id,
					order_label_status: form.order_label_status,
					order_parameter: form.order_parameter,
					order_paramter_type: form.order_paramter_type,
					order_srot_app: form.order_srot_app,
					order_shelf: form.order_shelf,
					order_unit: form.order_unit,
					purchase_restrictions: form.purchase_restrictions,
					order_images: form.order_images,
					category,
					seller_id
				}
			}).then((res) => {
				this.isSubmiting = false;
				if (res.code == 0) {
					this.$Rq.requestAuth({
						url: this.$Api.commodityDetailAdd,
						method: 'post',
						data: {
							order_id: this.pageParam.id,
							type: form.order_paramter_type,
							order_info_id: this.pageParam.id,
							order_info: form.order_parameter
						}
					}).then((res) => {
						this.isSubmiting = false;
						if (res.code == 0) {
							this.$Utils.showSuccess(res.msg);
							this.handleViewOrderLabel();
							this.getList(this.pageParam.id);
							this.current = 0;
						} else {
							this.$Utils.showTipInfo(res.msg);
						}
					}).catch((err) => {
						this.isSubmiting = false;
					});

				} else {
					this.$Utils.showTipInfo(res.msg);
				}
			}).catch((err) => {
				this.isSubmiting = false;
			});
		},
	}
};
</script>

<style>
.demo-upload-list {
	display: inline-block;
	width: 60px;
	height: 60px;
	text-align: center;
	line-height: 60px;
	border: 1px solid transparent;
	border-radius: 4px;
	overflow: hidden;
	background: #fff;
	position: relative;
	box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
	margin-right: 4px;
}

.demo-upload-list img {
	/*width: 100%;
	height: 100%;*/
}

.demo-upload-list-cover {
	display: none;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
	display: block;
}

.demo-upload-list-cover i {
	color: #fff;
	font-size: 20px;
	cursor: pointer;
	margin: 0 2px;
}

.w-e-toolbar {
	z-index: 2 !important;
}

.w-e-menu {
	z-index: 2 !important;
}

.w-e-text-container {
	z-index: 1 !important;
}
</style>
<style lang="scss">
@import "commodityEdit.scss";
</style>
